import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import Home from "./pages/Home";
import Settings from "./pages/Settings";
import PrivateSuite from "./pages/PrivateSuite";
import PrivateSuites from "./pages/PrivateSuites";
import ProfessionalsList from "./pages/ProfessionalsList";
import DetailPagePrivateSuite from "./pages/DetailPagePrivateSuite";
import DetailPageProfessional from "./pages/DetailPageProfessional";
import LoginPage from "./pages/LoginPage";
import ProfileSettings from "./pages/ProfileSettings";
import ChangePassword from "./pages/ChangePassword";
import PolicyEditor from "./pages/PolicyEditor";
import PolicyView from "./pages/PolicyView";
import ChatPage from "./pages/ChatPage";
import NotFound from "./pages/NotFound";
import PrivateRoute from "./components/PrivateRoute";
import Salons from "./pages/Salons";
import DetailPageSalon from "./pages/DetailPageSalon";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";
import SupportPage from "./pages/SupportPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FeedbackListPage from "./pages/FeedbackListPage";
import TermsEditor from "./pages/TermsEditor";
import Support from "./pages/Support";
function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditionsPage />}
          />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/support" element={<SupportPage />} />

          {/* Protected Routes */}
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          >
            <Route index element={<Home />} />
            <Route path="settings" element={<Settings />} />
            {/* <Route path="private-suite" element={<PrivateSuite />} /> */}
            <Route path="private-suites" element={<PrivateSuites />} />
            <Route path="support-list" element={<Support />} />
            <Route path="professionals-list" element={<ProfessionalsList />} />
            
            <Route
              path="private-suite/:id"
              element={<DetailPagePrivateSuite />}
            />

            <Route
              path="professionals-list/:id"
              element={<DetailPageProfessional />}
            />
            <Route path="feedback-list" element={<FeedbackListPage />} />
            <Route path="profile-settings" element={<ProfileSettings />} />
            <Route path="change-password" element={<ChangePassword />} />
            <Route path="policy-editor" element={<PolicyEditor />} />
            <Route path="terms" element={<TermsEditor />} />

            <Route path="policy-view" element={<PolicyView />} />
            <Route path="chat" element={<ChatPage />} />
            <Route path="salons" element={<Salons />} />
            <Route path="salons/:id" element={<DetailPageSalon />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
}

export default App;
